import { Component, createElement } from 'react';
import { connect } from 'react-redux';

import { TextKey } from '@mews-distributor/common';
import { AppContent, Container } from '@optimus-web/core';
import { StyledTransitionGroup } from '@optimus-web/helpers';

import { viewMapper } from '../mappers/viewMapper/viewMapper';

import { isDeprecatedDomainError } from '../services/error/selectors';
import { ApplicationState } from '../types';
import { ErrorHandler, Loader } from './common';
import { DeprecationError } from './common/DeprecationError';
import { View } from './View';

class BaseRouter extends Component {
    ref: HTMLDivElement | null = null;

    handleRef = (node: HTMLDivElement | null) => {
        if (node !== null) this.ref = node;
    };

    componentDidUpdate(prevProps: $TSFixMe) {
        if ((this.props as $TSFixMe).currentRoute !== prevProps.currentRoute) {
            this.scrollTop();
        }
    }

    scrollTop = () => {
        const domElement = this.ref;
        if (domElement) {
            domElement.scrollTop = 0;
        }
    };

    render() {
        let loadingError;
        let element;

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if ((this.props as $TSFixMe).hasAppFailed) {
            loadingError = ErrorHandler;
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        } else if (!(this.props as $TSFixMe).currentRoute) {
            loadingError = (props: $TSFixMe) => <Loader fill {...props} />;
        } else {
            element = (this.props as $TSFixMe).views[(this.props as $TSFixMe).currentRoute];
        }

        const ViewContent =
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            element &&
            createElement(element, {
                scrollTop: this.scrollTop,
                statusTextKey: TextKey.LoadingBookingEngine,
                ...(this.props as $TSFixMe).viewProps,
            });

        const LoadingError =
            loadingError &&
            createElement(loadingError, {
                scrollTop: this.scrollTop,
                statusTextKey: TextKey.LoadingBookingEngine,
                ...(this.props as $TSFixMe).viewProps,
            });

        const childrenProps = {
            transition: (this.props as $TSFixMe).transition,
        };

        const isLoading =
            (this.props as $TSFixMe).currentRoute == null && (this.props as $TSFixMe).hasAppFailed !== true;

        const content = (
            <>
                <Container aria-live="assertive" height="100%" position="absolute" top="0" left="0" right="0">
                    {LoadingError}
                </Container>
                {ViewContent}
            </>
        );

        return (
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            <StyledTransitionGroup childrenProps={childrenProps}>
                {/* @ts-expect-error $TSFixMeError: Property 'transition' is missing in type '{ children: Element; key: any; }' but required in type 'ViewProps'. */}
                <View key={(this.props as $TSFixMe).currentRoute}>
                    <AppContent aria-busy={isLoading} ref={this.handleRef}>
                        {(this.props as $TSFixMe).hasDeprecatedError === true ? <DeprecationError /> : content}
                    </AppContent>
                </View>
            </StyledTransitionGroup>
        );
    }
}

const connectDeprecatedError = connect((state: ApplicationState) => ({
    hasDeprecatedError: isDeprecatedDomainError(state),
}));

export const Router = connect(viewMapper)(connectDeprecatedError(BaseRouter));
